import { Fancybox } from "@fancyapps/ui";
import { useEffect } from "react";
import galleryData from "../utils/galleryData"
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default function GalleryNew() {
  useEffect(() => {
    Fancybox.bind("[data-fancybox]", {
      Thumbs: { autoStart: true },
      Toolbar: { display: ["close"] },
    });

    return () => Fancybox.destroy();
  }, []);

  return (
    <div className="gallery-container">
      {galleryData.map((yearItem) => (
        <div key={yearItem.year} className="year-section">
          <h2>{yearItem.year}</h2>

          {yearItem.festivals.map((festival) => (
            <div key={festival.slug} className="festival-section">
              <h3>{festival.name}</h3>

              <div className="gallery-grid">
                {festival.images.map((img, index) => {
                  const imagePath = `/gallery/${yearItem.year}/${festival.slug}/${img}`;

                  return (
                    <a
                      key={index}
                      href={imagePath}
                      data-fancybox={`${yearItem.year}-${festival.slug}`}
                      data-caption={`${festival.name} (${yearItem.year})`}
                    >
                      <img
                        src={imagePath}
                        alt={festival.name}
                        className="gallery-img"
                        loading="lazy"
                      />
                    </a>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
